import React from 'react';
import cn from 'classnames';
import CellContent from '../../common/CellContent/CellContent';
import IndicatorBadge from '../../common/IndicatorBadge/IndicatorBadge';
import styles from './IndicatorsRow.module.scss';

const IndicatorsRow = ({
  className,
  indicators,
  squareIndicator = false,
  isBorder = false,
  ...props
}) => {
  return (
    <ul
      {...props}
      className={cn(styles.list, className)}
    >
      {indicators.map((indicator) => (
        <li
          key={indicator.id}
          className={styles.item}
        >
          <CellContent
            containerClassName={styles.content}
            topRowContent={indicator.value}
            icon={
              <IndicatorBadge
                bgColor={indicator.bg}
                isSquare={squareIndicator}
                isBorder={isBorder}
              />
            }
          />
        </li>
      ))}
    </ul>
  );
};

export default IndicatorsRow;
